import { render, staticRenderFns } from "./releaseList.vue?vue&type=template&id=33db5c6a&scoped=true"
import script from "./releaseList.vue?vue&type=script&lang=js"
export * from "./releaseList.vue?vue&type=script&lang=js"
import style0 from "./releaseList.vue?vue&type=style&index=0&id=33db5c6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33db5c6a",
  null
  
)

export default component.exports